import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { display_toggle_face_visibility } from '../../ui_display';
import { shift_pressed } from '@frontend/keypress';
import isolate_faces_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/isolate_faces.svg';
import { img } from '@phi/components';
import IsolateFacesTooltip from './IsolateFacesTooltip';

export const IsolateFacesIcon = isolate_faces_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        disabled() {
            return this.coming_soon
                || this.state.editing_reference_sketches;
        },

        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show/hide faces';
        },

        selected() {
            return this.state.tut_stage === 1;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                display_toggle_face_visibility(false, false, shift_pressed());
        },

        onLongClick() {
            if (this.disabled)
                return;
            else
                display_toggle_face_visibility(false, false, true);
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.selected,
            active: !this.state.currently_hiding_faces,
            id: 'isolate-faces-button',
            tippy: 'top',
            long: true,
            onClick: this.onClick,
            onLongClick: this.onLongClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(isolate_faces_svg, this.alt),
            tooltip: IsolateFacesTooltip,
        });
    }
});
